var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "field",
    {
      attrs: {
        label: _vm.label,
        disabled: _vm.disabled,
        inline: _vm.inline,
        indent: _vm.indent,
        "error-text": _vm.errorText,
      },
    },
    [
      _c("dropdown-field", {
        attrs: {
          source: _vm.source,
          "text-field": "name",
          "auto-assign": _vm.autoAssign,
          placeholder: _vm.placeholder,
          clearable: _vm.clearable,
          searchable: "",
        },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }